import { ButtonPropsWithLabel } from 'src/components/Dialog';
import { Stack } from 'src/components/Stack';
import { Typography } from 'src/components/Typography';

import { ActionsList } from './ActionsList';
import { BlockingReasonList } from './BlockingReasonList';
import { UserDetails } from './UserDetails';
import { CheckinBlockerUser } from './_types';

export function UserContent({
  users,
  actions,
  getBlockerActions,
  showUserDetails = false,
}: {
  users: CheckinBlockerUser[];
  actions?: ButtonPropsWithLabel[];
  getBlockerActions?: (
    user: CheckinBlockerUser,
    blocker: CheckinBlockerUser['blockers'][number]
  ) => ButtonPropsWithLabel[] | undefined;
  showUserDetails?: boolean;
}) {
  return (
    <Stack spacing={4} sx={{ width: '100%' }}>
      {users.map((user, index) => (
        <Stack
          key={user.id != null && user.id !== '' ? user.id : `checkin-blocker-${index}`}
          spacing={4}
          sx={{ width: '100%' }}
        >
          {(user.name ?? '').trim() ? (
            showUserDetails ? (
              <UserDetails user={user} />
            ) : (
              <Typography variant="h6">{user.name}</Typography>
            )
          ) : null}
          <BlockingReasonList
            blockers={user.blockers}
            getBlockerActions={(blocker) => getBlockerActions?.(user, blocker)}
            userId={user.id ?? ''}
          />
        </Stack>
      ))}

      {!!actions && <ActionsList actions={actions} />}
    </Stack>
  );
}
